/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  Input
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StepsService } from '@shared/services/steps/steps.service';
import { MapsAPILoader } from '@agm/core';
import { GOOGLE_ADDRESS_COMPONENT_EQUIVALENT } from '@shared/constants/google-place.ts';
import { SIGNUP_HEADERS } from '@shared/constants/signup-headers.ts';
import { ContactInformationService } from '@shared/api/steps/contact-information/contact-information.service';
import { PreOrderService } from '@modules/pre-order/api/pre-order/pre-order.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SignUpSuccessComponent } from '@shared/components/modals/sign-up-success/sign-up-success.component';
import { ViewportService } from '@shared/services/viewport/viewport.service';
declare const google;

@Component({
  selector: 'contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss']
})
export class ContactInformationComponent implements OnInit, AfterViewInit {
  contactInformationForm: FormGroup;
  fieldFilleds;
  userFirstName;
  isDesktop;
  isTablet;
  isMobile;
  moduleName;
  isPreOrder;
  modalRef: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-sm'
  };

  @ViewChild('search')
  searchElementRef: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 500);
  }

  constructor(
    private formBuilder: FormBuilder,
    private _stepsService: StepsService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _stepContactInformationService: ContactInformationService,
    private changeDetectorRef: ChangeDetectorRef,
    private _preOrderService: PreOrderService,
    private router: Router,
    private modalService: BsModalService,
    private _viewportService: ViewportService
  ) {
    this._viewportService.updatingView.subscribe(() => {
      this.isDesktop = this._viewportService.isDesktop();
      this.isTablet = this._viewportService.isTablet();
      this.isMobile = this._viewportService.isMobile();
      if (this._stepsService.getCurrentStep() === 1) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.moduleName = this._stepsService.getModuleName();
    if (!this.moduleName) {
      this.router.navigate(['/app/properties']);
    }
    this.isPreOrder = this._stepsService.isCurrentModulePreOrder(
      this.moduleName
    );
    this.contactInformationForm = this.formBuilder.group({
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      phone: ['', Validators.required]
    });
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['address'],
          componentRestrictions: { country: 'us' }
        }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.fillAddressForm(place);
        });
      });
    });
  }

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }

  get controls() {
    return this.contactInformationForm.controls;
  }

  submit() {
    if (this.contactInformationForm.invalid) {
      return;
    }
    this.setContactInformation(this.contactInformationForm);
    if (this.isPreOrder) {
      this._stepsService.setHeaderTexts(
        SIGNUP_HEADERS.CONFIRM_PRE_ORDER_DETAILS
      );
      this._stepsService.setDoneSteps([0, 1]);
      this._stepsService.setTransitionDirection('RIGHT');
      this._stepsService.setCurrentStep(2);
    }
  }

  fillAddressForm(place) {
    const phoneNumber = this.contactInformationForm.controls['phone'].value;
    this.contactInformationForm.reset();
    if (!!phoneNumber) {
      this.contactInformationForm.controls['phone'].setValue(phoneNumber);
    }
    const placeComponents = place.address_components;
    this.contactInformationForm.controls['state'].setValue(
      this.getLongName(
        placeComponents,
        GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.STATE
      )
    );
    this.contactInformationForm.controls['zip'].setValue(
      this.getLongName(placeComponents, GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.ZIP)
    );

    this.contactInformationForm.controls['city'].setValue(
      this.getLongName(
        placeComponents,
        GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.CITY
      )
    );
    if (place.name !== undefined) {
      this.contactInformationForm.controls['addressLine1'].setValue(place.name);
    }

    if (
      place.vicinity !== undefined &&
      !this.checkVicinityExist(place.vicinity)
    ) {
      this.contactInformationForm.controls['addressLine2'].setValue(
        place.vicinity
      );
    }
  }

  getLongName(placeComponents, fieldType) {
    this.fieldFilleds = [];
    let componentExist: { [key: string]: any } = {};
    componentExist = placeComponents.find(component => {
      const componentTypes = component.types || [];
      const typeExist = componentTypes.filter(type => type === fieldType);
      return typeExist.length > 0;
    });
    if (
      componentExist !== undefined &&
      Object.keys(componentExist).length > 0
    ) {
      this.fieldFilleds.push(componentExist);
    }
    return (
      (componentExist !== undefined &&
        componentExist.hasOwnProperty('long_name') &&
        componentExist.long_name) ||
      ''
    );
  }

  checkVicinityExist(vicinity) {
    const doesExist = this.fieldFilleds.filter(keyword => {
      return (
        (keyword !== undefined &&
          (keyword.hasOwnProperty('long_name') &&
            keyword.long_name === vicinity)) ||
        (keyword.hasOwnProperty('short_name') &&
          keyword.short_name === vicinity)
      );
    });

    return doesExist.length > 0;
  }

  setContactInformation(details) {
    const info = Object.assign({}, details.value);

    this._stepContactInformationService
      .setContactInformation(info, this._stepsService.getSession('username'))
      .subscribe();
    this._preOrderService
      .setPreOrderStep(this._stepsService.getSession('username'), 2)
      .subscribe(() => {
        this._stepsService.setSession('step_id', 2);
        if (!this.isPreOrder) {
          this.showSignUpSuccessModal();
        }
      });
  }

  getContactInformation() {
    this._stepContactInformationService
      .getContactInformation(this._stepsService.getSession('username'))
      .subscribe(res => {});
  }

  showSignUpSuccessModal() {
    this.modalConfig.ignoreBackdropClick = true;
    this.modalConfig.class = 'modal-md';
    this.modalRef = this.modalService.show(
      SignUpSuccessComponent,
      this.modalConfig
    );
  }
}
